// extracted by mini-css-extract-plugin
module.exports = {"space":"PartnerEditModal_space__3iSbH"};